module.exports = __webpack_public_path__ + "static/media/collage_1.229e83bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/collageGame/collage_1.jpg
// module id = 2255
// module chunks = 0